module.exports = __webpack_public_path__ + "img/world-img.e82fbef3.svg";